import { ClassType } from '@frontend/common';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export enum SlotStateName {
    SLOT_ANY_STATE = 'slot_any_state',
    SLOT_CREATED = 'slot_created',
    SLOT_EMPTY = 'slot_empty',
    SLOT_OCCUPIED = 'slot_occupied'
}

export class SlotState {
    static readonly SLOT_ANY_STATE = new SlotState(
        SlotStateName.SLOT_ANY_STATE,
        (
            <FormattedMessage
                id='SlotState.any_state'
                description='The displayed value for the SlotState any_state'
                defaultMessage='Any state'
            />
        )
    );
    static readonly SLOT_CREATED = new SlotState(
        SlotStateName.SLOT_CREATED,
        (
            <FormattedMessage
                id='SlotState.created'
                description='The displayed value for the SlotState created'
                defaultMessage='Created'
            />
        )
    );
    static readonly SLOT_EMPTY = new SlotState(
        SlotStateName.SLOT_EMPTY,
        (
            <FormattedMessage
                id='SlotState.empty'
                description='The displayed value for the SlotState empty'
                defaultMessage='Empty'
            />
        )
    );
    static readonly SLOT_OCCUPIED = new SlotState(
        SlotStateName.SLOT_OCCUPIED,
        (
            <FormattedMessage
                id='SlotState.occupied'
                description='The displayed value for the SlotState occupied'
                defaultMessage='Occupied'
            />
        )
    );

    static readonly ALL = [SlotState.SLOT_ANY_STATE, SlotState.SLOT_CREATED, SlotState.SLOT_EMPTY, SlotState.SLOT_OCCUPIED];

    private constructor(
        public readonly value: SlotStateName,
        public readonly displayName: React.ReactNode
    ) {}

    static getByValue(state: SlotStateName): SlotState | undefined {
        return this.ALL.find((s) => s.value === state);
    }

    static getType(state: SlotStateName): ClassType {
        switch (state) {
            case SlotStateName.SLOT_EMPTY:
                return ClassType.SUCCESS;
            case SlotStateName.SLOT_CREATED:
                return ClassType.WARNING;
            case SlotStateName.SLOT_OCCUPIED:
                return ClassType.INFO;
            default:
                return ClassType.SECONDARY;
        }
    }
}
